import React from 'react'
import { Link } from 'react-router-dom'
import { LOGS_SCHEMA_NAME } from 'api/logs'
import { CRUD_PATH as parentPath } from '../../../constants'

const NameFormatter = ({ value, dependentValues: { id } }) => (
  <Link to={`/${parentPath}/${id}/${LOGS_SCHEMA_NAME}`}>
    {value}
  </Link>
)

export default NameFormatter
